import { __awaiter, __generator, __spreadArray } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import CloseOutlined from "@mui/icons-material/CloseOutlined";
import CheckIcon from "@mui/icons-material/Check";
import { IosShareOutlined } from "@mui/icons-material";
import { setLoading, setModal, setSnackbar } from "../../store/slices";
import { ModalKeys } from "../../components/modal/modalKeys";
import { TripMemberStatus } from "../../utils/enums/TripMemberStatus";
import { getTripDetails, tripMembershipAction, } from "../../services/api/TripDetailsService";
import { inviteUsersToTrip } from "../../services/api/EventCreationServices";
import useApiWrapper from "../../hooks/apiWrapper";
import TripActionButtons from "../../components/buttons/trip-actions/TripActionButtons";
import { CustomIcon, ExpandableList, WrapperContainer, } from "@corporate-trip-planner-fe/ui-styles";
import TripCoverBanner from "../../components/common/trip-cover-banner/TripCoverBanner";
import TripItineraryCard from "../../components/common/trip-itinerary/TripItineraryCard";
import InfoListCard from "../../components/common/infoList-card/InfoListCard";
import { TripDetailsBody, PageLayout, MainColumn, SidebarColumn, MobileActionBar, MobileActionBarActions, OverviewText, Tag, TagList, HighlightItem, HighlightDot, } from "./trip-details.style";
import { tripDetailsTokens as t } from "../../components/trips/trip-details/trip-details.tokens";
import TripStatsBar from "../../components/trips/trip-details/TripStatsBar";
import TripSectionCard from "../../components/trips/trip-details/TripSectionCard";
import TripReviewsCard from "../../components/trips/trip-details/TripReviewsCard";
import TripDetailsSidebar from "../../components/trips/trip-details/TripDetailsSidebar";
import TripBudgetCard from "../../components/trips/trip-details/TripBudgetCard";
var tagVariants = ["default", "olive", "amber"];
var TripDetails = function () {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    var dispatch = useDispatch();
    var tripId = useParams().tripId;
    var _j = useState(null), trip = _j[0], setTripDetails = _j[1];
    var _k = useState(TripMemberStatus.NOT_JOINED), userStatus = _k[0], setUserStatus = _k[1];
    var _l = useState(false), actionLoading = _l[0], setActionLoading = _l[1];
    var apiWrapper = useApiWrapper().apiWrapper;
    var fetchTripDetails = function (id) { return __awaiter(void 0, void 0, void 0, function () {
        var res, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(setLoading(true));
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, getTripDetails(id)];
                case 2:
                    res = _a.sent();
                    setTripDetails(res);
                    return [3 /*break*/, 5];
                case 3:
                    err_1 = _a.sent();
                    console.error("Error fetching trip details:", err_1);
                    dispatch(setSnackbar({
                        message: "Failed to fetch trip details",
                        severity: "error",
                        open: true,
                    }));
                    return [3 /*break*/, 5];
                case 4:
                    dispatch(setLoading(false));
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var submitInviteUsers = function (id, payload) { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, 3, 4]);
                    return [4 /*yield*/, apiWrapper(function () { return inviteUsersToTrip(id, payload); })];
                case 1:
                    _a.sent();
                    dispatch(setSnackbar({
                        message: "Invites sent successfully",
                        severity: "success",
                        open: true,
                    }));
                    return [3 /*break*/, 4];
                case 2:
                    error_1 = _a.sent();
                    console.error(error_1);
                    dispatch(setSnackbar({
                        message: "Some issue occurred",
                        severity: "error",
                        open: true,
                    }));
                    return [3 /*break*/, 4];
                case 3:
                    dispatch(setLoading(false));
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleOpenInviteModal = function () {
        if (!trip || !tripId)
            return;
        dispatch(setModal({
            name: ModalKeys.INVITE_USERS,
            props: {
                trip: trip,
                tripId: tripId,
                tripName: trip.tripName,
                onSubmit: submitInviteUsers,
            },
            options: { hideHeader: true, size: "lg" },
        }));
    };
    var handleTripMembershipAction = function (id, action) { return __awaiter(void 0, void 0, void 0, function () {
        var res, error_2;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setActionLoading(true);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, apiWrapper(function () {
                            return tripMembershipAction({ tripId: id, action: action });
                        })];
                case 2:
                    res = _b.sent();
                    if ((_a = res.result) === null || _a === void 0 ? void 0 : _a.updatedStatus) {
                        setUserStatus(res.result.updatedStatus);
                    }
                    dispatch(setSnackbar({
                        message: res.message,
                        severity: [2107, 2112].includes(res.statusCode) ? "success" : "error",
                        open: true,
                    }));
                    if (tripId && [2107, 2112].includes(res.statusCode)) {
                        fetchTripDetails(tripId);
                    }
                    return [3 /*break*/, 5];
                case 3:
                    error_2 = _b.sent();
                    console.error(error_2);
                    dispatch(setSnackbar({
                        message: "Some issue occurred",
                        severity: "error",
                        open: true,
                    }));
                    return [3 /*break*/, 5];
                case 4:
                    setActionLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        if (trip) {
            setUserStatus(trip.userStatus);
        }
    }, [trip]);
    useEffect(function () {
        if (tripId)
            fetchTripDetails(tripId);
    }, [tripId]);
    var hasHighlights = !!((trip === null || trip === void 0 ? void 0 : trip.highlights) && trip.highlights.length > 0);
    var hasBudget = !!(((_a = trip === null || trip === void 0 ? void 0 : trip.budgetDetails) === null || _a === void 0 ? void 0 : _a.totalBudget) != null &&
        trip.budgetDetails.totalBudget > 0);
    var hasInclusionsOrExclusions = ((_c = (_b = trip === null || trip === void 0 ? void 0 : trip.inclusions) === null || _b === void 0 ? void 0 : _b.length) !== null && _c !== void 0 ? _c : 0) > 0 || ((_e = (_d = trip === null || trip === void 0 ? void 0 : trip.exclusions) === null || _d === void 0 ? void 0 : _d.length) !== null && _e !== void 0 ? _e : 0) > 0;
    var hasReviews = !!((trip === null || trip === void 0 ? void 0 : trip.reviews) && trip.reviews.length > 0);
    var membershipActions = tripId && trip ? (_jsx(TripActionButtons, { tripPrivacy: trip.privacySetting, userStatus: userStatus, actionLoading: actionLoading, onAcceptInvite: handleTripMembershipAction.bind(null, tripId, "ACCEPT_INVITE"), onDeclineInvite: handleTripMembershipAction.bind(null, tripId, "DECLINE_INVITE"), onJoin: handleTripMembershipAction.bind(null, tripId, "JOIN"), onRequestJoin: handleTripMembershipAction.bind(null, tripId, "REQUEST_JOIN"), onCancelRequestJoin: handleTripMembershipAction.bind(null, tripId, "CANCEL_REQUEST"), onLeave: handleTripMembershipAction.bind(null, tripId, "LEAVE") })) : null;
    return (_jsx(WrapperContainer, { "$margin": "0", "$padding": "0", "$textAlign": "left", children: trip && (_jsxs(TripDetailsBody, { children: [_jsx(TripCoverBanner, { trip: trip }), _jsx(TripStatsBar, { trip: trip }), _jsxs(PageLayout, { children: [_jsxs(MainColumn, { children: [_jsxs(TripSectionCard, { title: "Trip Overview", icon: "\uD83C\uDFD4\uFE0F", iconBg: t.rustLight, children: [_jsx(OverviewText, { children: trip.description || "No description provided." }), ((_f = trip.tripCategories) === null || _f === void 0 ? void 0 : _f.length) > 0 && (_jsx(TagList, { children: trip.tripCategories.map(function (cat, idx) { return (_jsx(Tag, { "$variant": tagVariants[idx % tagVariants.length], children: cat.label }, cat.value)); }) }))] }), hasHighlights && (_jsx(TripSectionCard, { title: "Trip Highlights", icon: "\u2728", iconBg: t.amberBg, children: _jsx(ExpandableList, { initialVisibleCount: 4, mobileOnly: true, gridOnDesktop: true, items: trip.highlights.map(function (item, idx) { return (_jsxs(HighlightItem, { children: [_jsx(HighlightDot, {}), item] }, idx)); }) }) })), hasBudget && trip.budgetDetails && (_jsx(TripBudgetCard, { budget: trip.budgetDetails })), hasInclusionsOrExclusions && (_jsx(InfoListCard, { title: "What's Included & Excluded", sections: __spreadArray(__spreadArray([], (((_g = trip.inclusions) === null || _g === void 0 ? void 0 : _g.length)
                                        ? [
                                            {
                                                subtitle: "Inclusions",
                                                items: trip.inclusions,
                                                icon: _jsx(CheckIcon, { sx: { fontSize: 20 } }),
                                                iconColor: "#2e6e4e",
                                            },
                                        ]
                                        : []), true), (((_h = trip.exclusions) === null || _h === void 0 ? void 0 : _h.length)
                                        ? [
                                            {
                                                subtitle: "Exclusions",
                                                items: trip.exclusions,
                                                icon: (_jsx(CloseOutlined, { sx: { fontSize: 20, fontWeight: "bold" } })),
                                                iconColor: "#c0401a",
                                            },
                                        ]
                                        : []), true) })), trip.itinerary && trip.itinerary.length > 0 && (_jsx(TripItineraryCard, { itinerary: trip.itinerary })), hasReviews && _jsx(TripReviewsCard, { reviews: trip.reviews })] }), _jsx(SidebarColumn, { children: _jsx(TripDetailsSidebar, { trip: trip, actions: membershipActions, onOpenInviteModal: handleOpenInviteModal }) })] }), _jsxs(MobileActionBar, { children: [_jsx(CustomIcon, { "$fontSize": "inherit", "$backgroundColor": "#d9dfe9", "$borderRadius": "16px", style: { flexShrink: 0 }, "$padding": "0.5rem", "$alignItems": "center", "$width": "20%", onClick: handleOpenInviteModal, children: _jsx(IosShareOutlined, { color: "action", fontSize: "small" }) }), _jsx(MobileActionBarActions, { children: membershipActions })] })] })) }));
};
export default TripDetails;
